export enum DataTestId {
    AddAnotherReservationButton = 'add-another-reservation-button',
    AdditionalInfo = 'additional-info',
    AgeCategoryOccupancyField = 'age-category-occupancy-field',
    Availability = 'availability',
    BookAnotherStayButton = 'book-another-stay-button',
    BookerSelection = 'booker-selection',
    ButtonProductAdded = 'button-product-added',
    ButtonProductNotAdded = 'button-product-not-added',
    CategoriesWithAlternativeTimesHeading = 'categories-with-alternative-times-heading',
    CategoriesWithoutAvailabilityHeading = 'categories-without-availability-heading',
    CategoryCard = 'category-card',
    CategoryCardAvailability = 'category-card-availability',
    CategoryCardMaxPersons = 'category-card-max-persons',
    CategoryCardName = 'category-card-name',
    CategoryDetailAvailability = 'category-detail-availability',
    CategoryDetailCard = 'category-detail-card',
    CategoryDetailDescription = 'category-detail-description',
    CategoryDetailMaxPersons = 'category-detail-max-persons',
    CheckoutBookingMyself = 'checkout-booking-myself',
    CheckoutBookingSomeoneElse = 'checkout-booking-someone-else',
    CheckoutFieldPrefix = 'checkout-field',
    CheckoutGuestDetailsHeading = 'checkout-guest-details-heading',
    CheckoutNextButton = 'checkout-next-button',
    CheckoutPaymentCardCVV = 'checkout-payment-card-cvv',
    CheckoutPaymentCardExpiration = 'checkout-payment-card-expiration',
    CheckoutPaymentCardName = 'checkout-payment-card-name',
    CheckoutPaymentCardNumber = 'checkout-payment-card-number',
    CheckoutPaymentHeading = 'checkout-payment-heading',
    CheckoutSpecialRequest = 'checkout-special-request',
    CheckoutView = 'checkout-view',
    CheckoutYourDetailsHeading = 'checkout-your-details-heading',
    ChildCount = 'child-count',
    ConfirmationView = 'confirmation-view',
    CurrencySelector = 'currency-selector',
    DateSuggestionButton = 'date-suggestion-button',
    DatesHeading = 'dates-heading',
    DatesNextButton = 'dates-next-button',
    DatesOccupancyHeader = 'dates-occupancy-header',
    DatesView = 'dates-view',
    EnableBooker = 'enable-booker',
    FromPriceValue = 'from-price-value',
    FromPriceWrapper = 'from-price-wrapper',
    HotelsView = 'hotels-view',
    LanguageSelector = 'language-selector',
    LocationSelect = 'location-select',
    LocationSelectItem = 'location-select-item',
    MarketingEmailsCheckbox = 'marketing-emails-checkbox',
    OccupancyContainer = 'occupancy-container',
    OccupancyRoomsSelector = 'occupancy-rooms-selector',
    OpenWithApril = 'open-with-April',
    OpenWithDisabledTracking = 'open-with-disabled-tracking',
    OpenWithEnabledTracking = 'open-with-enabled-tracking',
    OpenWithInitialOccupancies = 'open-with-initial-occupancies',
    OpenWithMarch = 'open-with-March',
    OpenWithSpanishLanguage = 'open-with-spanish-language',
    PriceFooterButton = 'price-footer-button',
    Product = 'product',
    ProductAdded = 'product-added',
    ProductItem = 'product-item',
    ProductItemChargingMode = 'product-item-charging-mode',
    ProductItemDescription = 'product-item-description',
    ProductItemImage = 'product-item-image',
    ProductItemName = 'product-item-name',
    ProductListCollapseButton = 'product-list-collapse-button',
    ProductListExpandButton = 'product-list-expand-button',
    ProductNotAdded = 'product-not-added',
    ProductsContainer = 'products-container',
    PromotedService = 'promoted-service',
    PromotedServiceAdded = 'promoted-service-added',
    PromotedServiceItem = 'promoted-service-item',
    PromotedServiceItemDescription = 'promoted-service-item-description',
    PromotedServiceItemImage = 'promoted-service-item-image',
    PromotedServiceItemName = 'promoted-service-item-name',
    PromotedServiceNotAdded = 'promoted-service-not-added',
    PromotionRatesHeading = 'promotion-rates-heading',
    PropertyCard = 'property-card',
    PropertyCardEnterpriseAddress = 'property-card-enterprise-address',
    PropertyCardEnterpriseAvailability = 'property-card-enterprise-availability',
    PropertyCardEnterpriseName = 'property-card-enterprise-name',
    RateItem = 'rate-item',
    RateItemButton = 'rate-item-button',
    RateItemDescription = 'rate-item-description',
    RateItemDiscount = 'rate-item-discount',
    RateItemName = 'rate-item-name',
    RateSettlementRuleDescriptionAmount = 'rate-settlement-rule-description-amount',
    RateSettlementRuleDescriptionLater = 'rate-settlement-rule-description-later',
    RateSettlementRuleDescriptionNow = 'rate-settlement-rule-description-now',
    RatesContainer = 'rates-container',
    RatesHeading = 'rates-heading',
    RatesView = 'rates-view',
    ReservationCounterDecrementButton = 'reservation-counter-decrement-button',
    ReservationCounterIncrementButton = 'reservation-counter-increment-button',
    RestrictionMaxAdvanceApplied = 'restriction-max-advance-applied',
    RestrictionMaxLengthApplied = 'restriction-max-length-applied',
    RestrictionMinAdvanceApplied = 'restriction-min-advance-applied',
    RestrictionMinLengthApplied = 'restriction-min-length-applied',
    RestrictionUniversalApplied = 'restriction-universal-applied',
    RoomsView = 'rooms-view',
    SelectCategoryHeading = 'select-category-heading',
    SelectLocationHeading = 'select-location-heading',
    SelectRateHeading = 'select-rate-heading',
    SpecialRequests = 'special-requests',
    SummaryCardCountsWrapper = 'summary-card-counts-wrapper',
    SummaryCardDate = 'summary-card-date',
    SummaryCardImage = 'summary-card-image',
    SummaryCardName = 'summary-card-name',
    SummaryCardOccupancy = 'summary-card-occupancy',
    SummaryCardPricing = 'summary-card-pricing',
    SummaryCardProducts = 'summary-card-products',
    SummaryCardRate = 'summary-card-rate',
    SummaryCardRateDescription = 'summary-card-rate-description',
    SummaryCardTime = 'summary-card-time',
    SummaryErrorMessage = 'summary-error-message',
    SummaryHeading = 'summary-heading',
    SummaryNextButton = 'summary-next-button',
    SummaryReservationCard = 'summary-reservation-card',
    SummaryView = 'summary-view',
    TaxLabel = 'tax-label',
    TermsAndConditionsCheckbox = 'terms-and-conditions-checkbox',
    ToggleExpandableBox = 'toggle-expandable-box',
    TotalBarTaxIncluded = 'total-bar-tax-included',
    TotalBarTotal = 'total-bar-total',
    TotalBarTotalValue = 'total-bar-total-value',
    UpsellListCollapseButton = 'upsell-list-collapse-button',
    UpsellListExpandButton = 'upsell-list-expand-button',
    UpsellsContainer = 'upsells-container',
    VoucherInput = 'voucher-input',
    VoucherLink = 'voucher-link',
    WidgetOpen = 'widget-open',
}
